/**
 * Parse a numeric value, with a fallback if parsing fails.
 * Accepts strings (JSON / env) and numbers already coerced by the driver.
 *
 * @param value The value to parse.
 * @param fallback The fallback number if parsing fails.
 * @returns The parsed float or the fallback.
 *
 * @example
 * parseFloat('3.14', 0); // 3.14
 * parseFloat(19, 0); // 19
 * parseFloat('invalid', 0); // 0
 */
export function parseFloat(
	value: string | number | null | undefined,
	fallback: number,
): number {
	if (typeof value === 'number') {
		return Number.isFinite(value) ? value : fallback;
	}

	const parsed = Number.parseFloat(value ?? '');

	return Number.isFinite(parsed) ? parsed : fallback;
}
